<template>
    <div class="col-md-12 col-lg-12 col-xl-9">

        <div class="sport-menu-tabs-sec">
            <!-- ***wallet section start here*** -->
            <WalletHeader/>

            <section class="recent-wrapper walletPage-wrap mt-0">
                <div class="container">
                    <div class="form-bank-con">
                        <div class="form-bank-wrapper"  v-if="Object.keys(paymentMethods).length > 0">
                            <div class="form-bank-item">
                                <div v-for="(paymentMethod, paymentMethodindex) in paymentMethods" :key="paymentMethodindex" @click="choosePaymentMethod(paymentMethod,paymentMethodindex)">
                                    <label class="flexRadioDefault-label" :for="'flexRadioDefault' + paymentMethodindex"  :class="{ 'active-selcted-bank' : activeTab == paymentMethodindex }">
                                        <div class="get-bonus-sec" v-if="paymentBonus?.[paymentMethod?.[0]?.method_id]">Get {{ paymentBonus?.[paymentMethod?.[0]?.method_id] }}% Bonus</div>
                                        <input class="flexRadioDefault-inp" type="radio"
                                            name="flexRadioDefault" :id="'flexRadioDefault' + paymentMethodindex"
                                            :checked="(activeTab == paymentMethodindex)">
                                        <div class="flexRadioDefault-content">
                                            <div class="bank-icon">
                                                <img loading="lazy" :src="methodIcons[paymentMethodindex]" />
                                            </div>
                                            <div class="flexRadioDefault-title">{{ paymentMethod[0].method_name }}</div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div v-else class="no-need-option-avil-sec">
                            {{$t('no-deposit-options-available-contact-admin!!','No Deposit Options Available.Contact Admin!!')}}
                        </div>
                        <span v-if="selectedPaymentDetails?.[0]?.method == 'bank'">You can add through a bank transfer</span>
                    </div>
                    <div class="withdraw-sec add-account-sec" v-if="isPaymentGateway">
                        <div class="hide-input-sec payment-gateway-sec">
                            <span>
                                Pay using our payemnt gateway
                            </span>
                            <span class="matka-but-dflex pg-btn">
                                <a href="Javascript:void(0);" @click="goToPaymentGateway()" class="thm-but">{{ $t('pay-now', 'Pay Now') }}</a>
                            </span>
                        </div>
                    </div>
                    <div v-if="selectedPaymentDetails?.length && !isPaymentGateway">
                        <div class="account-data" v-for="(bank, index) in selectedPaymentDetails" :key="index" @click="selectPaymentMethodAccount(bank)">
                            <div class="upi-card-list">
                                <div class="upi-payment-content">
                                    <div class="bank-transfer-sec " :key="accountKey" :class="{ 'active' : selectPaymentAccount?.account_number == bank?.account_number }">
                                        <div class="code-list">
                                            <div class="qr_scaner_sec file-uploader-qr-wrapper" v-if="bank?.qr_code">
                                                <figure>
                                                    <img loading="lazy" :src="bank?.qr_code" alt="QR-Code">
                                                </figure>
                                                <div class="qr-btn-group">
                                                    <button class="qr-btn" data-bs-toggle="modal" data-bs-target="#qrPreviewModal" @click="qrCode = bank?.qr_code">
                                                        <img loading="lazy" src="@/assets/images/qr-full-screen.svg" alt="qr-full-screen">
                                                    </button>
                                                    <button class="qr-btn" data-bs-toggle="modal" data-bs-target="#qrShareModal" @click="qrCode = (bank.qr_code)">
                                                        <img loading="lazy" src="@/assets/images/qr-share.svg" alt="qr-share">
                                                    </button>
                                                    <button class="qr-btn" @click="downloadQrImg(bank.qr_code, bank?.account_holder_name)">
                                                        <img loading="lazy" src="@/assets/images/qr-downloads.svg" alt="qr-downloads">
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="depositBank-item" v-if="bank?.account_number || account?.phone_number">
                                                <div class="depositBank-key">{{ bank?.account_number ? $t('account-number', 'Account Number') : $t('phone-number', 'Phone Number') }}
                                                    <span class="list-dost">:</span>
                                                </div>
                                                <div class="depositBank-value">{{ bank?.account_number ? bank?.account_number : account?.phone_number }}</div>
                                                <div class="copy-btn-tool-tips-sec">
                                                    <button class="copy-icon" @click="copyPaymentData(bank?.account_number ? $t('account-number', 'Account Number') : $t('phone-number', 'Phone Number'), account?.account_number ? account?.account_number : account?.phone_number)">
                                                        <img loading="lazy" src="@/assets/images/copy-icon.svg" alt="copy-icon">
                                                    </button>
                                                    <!-- <div class="copt_text_hover" v-if="copiedText == account?.account_number ? account?.account_number : account?.phone_number">
                                                        {{ $t('copied', ' Copied') }}!
                                                    </div> -->
                                                </div>
                                            </div>
                                            <div class="depositBank-item">
                                                <div class="depositBank-key">
                                                    {{ bank?.account_number ? $t('bank-name', 'Bank Name') :  $t('payment-method', 'Payment Method') }}
                                                    <span class="list-dost">:</span>
                                                </div>
                                                <div class="depositBank-value">{{ bank?.method_name}}</div>
                                                <div class="copy-btn-tool-tips-sec">
                                                    <button class="copy-icon" @click="copyPaymentData($t('bank-name', 'Bank Name'), bank.method_name)">
                                                        <img loading="lazy" src="@/assets/images/copy-icon.svg" alt="copy-icon">
                                                    </button>
                                                    <!-- <div class="copt_text_hover" v-if="copiedText == bank.method_name">
                                                        {{ $t('copied', ' Copied') }}!
                                                    </div> -->
                                                </div>
                                            </div>
                                            <div class="depositBank-item">
                                                <div class="depositBank-key">{{ bank?.account_number ? $t('ifsc-code', 'IFSC Code') : bank?.upi_id ? $t('upi-id', 'UPI ID') : $t('wallet-id', 'Wallet ID') }}
                                                    <span class="list-dost">:</span>
                                                </div>
                                                <div class="depositBank-value">{{ bank?.account_number ? bank?.ifsc_code : (bank?.upi_id || bank?.crypto_wallet_id) }}</div>
                                                <div class="copy-btn-tool-tips-sec">
                                                    <button class="copy-icon" @click="copyPaymentData(bank?.account_number ? $t('ifsc-code', 'IFSC Code') : bank?.upi_id ? $t('upi-id', 'UPI ID') : $t('wallet-id', 'Wallet ID'), bank?.account_number ? bank?.ifsc_code : (bank?.upi_id || bank?.wallet_id))">
                                                        <img loading="lazy" src="@/assets/images/copy-icon.svg" alt="copy-icon">
                                                    </button>
                                                    <!-- <div class="copt_text_hover" v-if="copiedText == bank?.account_number ? bank?.ifsc_code : (bank?.upi_id || bank?.wallet_id)">
                                                        {{ $t('copied', ' Copied') }}!
                                                    </div> -->
                                                </div>
                                            </div>
                                            <div class="depositBank-item">
                                                <div class="depositBank-key" :id="'account:' + accountKey">{{$t('account-holder-name', 'Account Holder Name')}}
                                                    <span class="list-dost">:</span>
                                                </div>
                                                <div class="depositBank-value">{{ bank?.account_holder_name}}</div>
                                                <div class="copy-btn-tool-tips-sec">
                                                    <button class="copy-icon" @click="copyPaymentData('Account Holder Name', bank.account_holder_name)">
                                                        <img loading="lazy" src="@/assets/images/copy-icon.svg" alt="copy-icon">
                                                    </button>
                                                    <!-- <div class="copt_text_hover" v-if="copiedText == bank.account_holder_name">
                                                        {{ $t('copied', ' Copied') }}!
                                                    </div> -->
                                                </div>
                                            </div>
                                            <div class="depositBank-item" v-if="bank?.crypto_wallet_id">
                                                <div class="depositBank-key" :id="'account:' + accountKey">Deposit Amount
                                                    <span class="list-dost">:</span>
                                                </div>
                                                <div class="depositBank-value">
                                                    {{ (depositAmount/bank?.multiplier_value)?.toFixed(2) }} {{ bank?.method_name}}
                                                    <span>( at x{{ Number(bank?.multiplier_value) }} )</span>
                                                </div>
                                                <div class="copy-btn-tool-tips-sec">
                                                    <button class="copy-icon" @click="copyPaymentData('Deposit Amount', (depositAmount/bank?.multiplier_value))">
                                                        <img loading="lazy" src="@/assets/images/copy-icon.svg" alt="copy-icon">
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bank-upi-sec">
                            <div class="withdraw-sec add-account-sec position-relative mt-1">
                                <div class="uploadFile-wrap" v-if="!previewImageUtr">
                                    <h5 class="uploadFile-title-wrap">{{$t('upload-your-payment-slip-below', 'Upload your payment slip below')}} <small style="color: red;">*</small>
                                        <!-- <span class="info-sec-icon">
                                            <img src="@/assets/images/info-icon.svg" alt="info-icon" loading="lazy">
                                            <div class="info-tooltip">
                                                <ul>
                                                    <li>1. {{$t('upload-a-screenshot-of-a-valid-qr-code-to-proceed', 'Upload a screenshot of a valid QR code to proceed')}}</li>
                                                    <li>2. {{$t('if-qr-code-is-not-detected-exchange-will-not-be-responsible-for-the-losses', 'If QR code is not detected, Exchange will not be responsible for the losses')}}</li>
                                                </ul>
                                            </div>
                                        </span> -->
                                    </h5>
                                    <div class="file-upload-sec input-field">
                                        <label for="file" class="file-upload">
                                            <img loading="lazy" src="@/assets/images/file-icon.svg" alt="file-icon">
                                            <h6>{{$t('upload-screenshot', 'Upload screenshot')}}</h6>
                                        </label>
                                        <input class="form-control profit-input d-none" type="file" name="file"
                                                id="file" @change="fileUpdateFunc" accept=".png, .jpg, .jpeg, .webp">
                                    
                                        <div class="thm-error-text" v-if="showFileError && !previewImageUtr">
                                            <div>
                                                <p class="wrong-color">{{ $t('please-upload-payment-proof', 'Please Upload Payment Proof') }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="uploadFile-wrap" v-if="previewImageUtr">
                                    <h5 class="uploadFile-title-wrap">{{$t('payment-slip', 'Payment Slip')}}</h5>
                                    <div class="fileList">
                                        <img class="fileList-img" :src="previewImageUtr"  alt="file" loading="lazy"/>
                                        <button class="add-utr-again" @click="clearPaymentSlip()">&#10006;</button>
                                        <div class="timer loader_timer" v-if="utrLoader">
                                            <div class="loader_deposit">
                                            </div>
                                            <text id="myTimer" text-anchor="middle" x="100" y="110" style="font-size: 40px; fill:#343434;">
                                                {{ timerValue }}
                                            </text>
                                        </div>
                                    </div>
                                </div>
                                <div class="input-field">
                                    <label class="form-label">{{ $t('utr-number','UTR Number')}} 
                                        <small style="color: red;" v-if="selectPaymentAccount?.method != 'wallet'">*</small></label>
                                    <input class="form-control" type="text" v-model="utrNumber" @input="validateUTR(), manualUtrNumber = 1" :placeholder="$t('enter-utr-number', 'Enter UTR number')" :maxlength="selectPaymentAccount?.method != 'wallet' ? 15 : 128"/>
                                    <!-- ****** for eroor text ***** -->
                                    <div class="thm-error-text" v-if="selectPaymentAccount?.method != 'wallet' && utrerror && init">
                                        <div>
                                            <p class="wrong-color">{{$t('enter-valid-utr','Please Enter UTR Number')}}</p>
                                        </div>
                                    </div>
                                    <div class="thm-error-text" v-if="selectPaymentAccount?.method != 'wallet' && utrLimitError && init">
                                        <div>
                                            <p class="wrong-color">{{$t('utr-limit-msg','UTR number must be 10 to 15 digit')}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="input-field">
                                    <label for="exampleFormControlInput1">{{ $t('amount', 'Amount') }} <small style="color: red;">*</small></label>
                                    <input type="number" class="form-control btn-disabled" v-model="amount" readonly />
                                </div>
                            </div>
                        </div>
                        <div class="withdraw-fix-sec continue-btn">
                            <a @click="walletDepositSubmitBtn()" type="button" id="account-successfully" class="btnTheme-yellow " :class="{ 'btn-loading': loading }">{{$t('submit-request', 'Submit Request')}} <span><b></b><b></b><b></b></span></a>
                        </div>
                    </div>
                    <WalletInstructions instructionType="deposit" />
                </div>
            </section>

            <QrCodeModal :qrCode="qrCode"/>
            <QrCodeShareModal :qrCode="qrCode"/>

            
        </div>
        <Support></Support>
    </div>
    <AdvertSideBar></AdvertSideBar>
    <Loader v-if="loading" />
</template>

<script>
import { mapGetters } from 'vuex'
import { defineAsyncComponent } from 'vue';
import ocrUtr from '../services/ocrUtr';
import { createWorker } from 'tesseract.js';
import {  
    getParentPaymentsMethods,
    onUploadImage,
    submitDepositAmount,
    getPaymentGatewayUrl
} from '../services/depositPayment';
import WalletInstructions from '../components/WalletInstructions.vue';
import QrCodeShareModal from '../components/QrCodeShareModal.vue';
import Loader from '@/shared/components/loader/Loader.vue';
import QrCodeModal from '../components/QrCodeModal.vue';
import WalletHeader from '../components/WalletHeader.vue';
import Support from '@/shared/components/support/Support.vue';
import AdvertSideBar from '@/shared/components/advertisment/AdvertSideBar.vue';
export default {
    name: 'DepositPaymentMethods',
    extends: ocrUtr,
    inject: ['walletConfig'],
    components: {
        AdvertSideBar,
        Support,
        WalletHeader,
        QrCodeModal,
        Loader,
        QrCodeShareModal,
        WalletInstructions,
    },
     data() {
        return {
            socialLink:false,
            has_edited_utr:1,
            paymentMethods: [],
            selectedPaymentMethod: [],
            utrNumber: null,
            fetchedUtr:null,
            file: undefined,
            loading: false,
            selectPaymentAccount: null,
            selectedPaymentDetails: [],
            previewImageUtr: null,
            manualUtrNumber: 0,
            qrCode: null,
            utrLoader: false,
            t: 6, 
            interval: 30, 
            angle: 0, 
            angle_increment: 360 / 9, 
            intervalCounter: 0,
            timerValue: 9,
            copiedText:'', 
            uploadedImage: null,
            timer: null, 
            amount: null,
            showFileError: false,
            utrerror:false,
            utrLimitError:false,
            init:false,
            currentImgLink: null,
        }
    },
    computed: {
        ...mapGetters([
            'depositAmount',
            'siteSettings',
            'bonusData'
        ]),
        methodIcons() {
            let iconObj = {};
            this.walletConfig?.payment_method?.forEach(element => {
                iconObj[element.method_name] = element.icon
            });
            this.walletConfig?.bank_list?.forEach(element => {
                iconObj[element.bank_name] = element.icon
            });
            return iconObj
        },
        paymentBonus() {
            if (!this.bonusData || !Array.isArray(this.bonusData)) {
                return {};
            }
        
            const paymentBonusData = this.bonusData.filter(bd => bd.bonusType === 'payment bonus');
            
            if (paymentBonusData.length === 0) {
                return {};
            }
            
            return paymentBonusData.reduce((methodBonusMap, bonusElement) => {
                try {
                    const methodIds = JSON.parse(bonusElement.methodIds);
                    if (Array.isArray(methodIds)) {
                        methodIds.forEach(methodId => {
                            methodBonusMap[methodId] = bonusElement.percentage;
                        });
                    }
                } catch (error) {
                    console.warn('Failed to parse methodIds for payment bonus:', bonusElement.methodIds, error);
                }
                return methodBonusMap;
            }, {});
        }
    },
    mounted(){
        this.getParentPaymentMethods();
        this.amount = this.$store.getters.depositAmount;
        this.socialLink = false
    },
    methods:{
        selectPaymentMethodAccount(paymentAccount) {
            this.socialLink = false
            this.selectPaymentAccount = paymentAccount;
        },
        async getParentPaymentMethods(reconnectTry = 0){
            try {
                let response = await getParentPaymentsMethods( reconnectTry, this.depositAmount );
                if(response?.data){
                    this.paymentMethods = response?.data;
                    let nonSocialStartIndex = response?.nonSocialStartIndex
                    this.activeTab = Object.keys(this.paymentMethods)[nonSocialStartIndex]
                    this.choosePaymentMethod(this.paymentMethods[this.activeTab], this.activeTab);
                }
            }catch(error) {
                
                if(reconnectTry < 3 && !error) {
                this.getParentPaymentMethods(reconnectTry + 1);
            }
            else {
                this.loading = false;
                this.$store.dispatch('setGlobalLoader',false);
                if (error) {
                    console.log('error',error);
                    this.$router.back();
                    this.$errorToast(error[0]);
                }
            }
            }
        },
        capitalizeText(text){
            if(typeof text == 'string'){
                text = text.trim();
                return text.toLowerCase().split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
            }else
                return text
        },
        async copyPaymentData(catagory, accountData) {
            try {
                await navigator.clipboard.writeText(accountData);
                this.copiedText = accountData;
                this.$successToast(this.capitalizeText(catagory +' '+ 'Copied Successfully'))
                setTimeout(() => {
                    this.copiedText = null;
                    document.querySelectorAll('copy-icon').forEach(el => {
                        el.style.color = '#000000';
                    });
                }, 1000);
            } catch (err) {
                console.error(this.capitalizeText('Failed to copy: ', err));
            }
        },
        copyImgUrl() {
            var input = document.createElement('textarea');
            input.innerHTML = this.currentImgLink;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$successToast('Successfully copied.');
        },

        downloadQrImg(imageUrl, name) {
            const link = document.createElement('a');
            link.href = imageUrl;
            link.download = name;
            link.target = '_blank';
            link.click();
        },

        walletDepositSubmitBtn() {
            this.init = true;
            if (!this.selectPaymentAccount) {
                this.$errorToast('Please select a payment method.');
                return
            } else if (!this.file || this.file == null) {
                this.showFileError = true;
                this.validateUTR();
                return;
            }
            this.walletDepositServiceCall();
        },
        async walletDepositServiceCall() {
            if(this.selectPaymentAccount?.method != 'wallet' && this.utrNumber.length < 11) return;
            this.has_edited_utr = this.fetchedUtr == this.utrNumber?0:1
            try {
                this.loading = true;
                let response = await submitDepositAmount({
                    accountDetails: this.selectPaymentAccount,
                    uploadedImage: this.uploadedImage,
                    depositAmount: this.depositAmount,
                    manual_utr: this.utrNumber,
                    has_edited_utr:this.has_edited_utr,
                    removeImage: this.clearPaymentSlip
                });
                console.log(response)
                this.loading = false;
            } catch (error) {
                console.log('eroror',error);
                
                this.$errorToast(error)
                this.loading = false;
            }
        },
        getAutoUrlServiceCall() {
            this.loading = true;
            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('amount', this.depositAmount);
            this.$apiCall('post', 'GET_AUTO_UTR', formData, 'wallet', null, 'changeHeaderContent').then(response => {
                this.loading = false;
                this.resetTimer();
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.utr) {
                            this.utrNumber = response?.data?.utr_number;
                        }
                    }
                }
            }).catch(error => {
                this.loading = false;
                this.resetTimer();
                this.file = undefined;
                this.previewImageUtr = null;
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        async recognize(prevImgs) {
            try {
                const img = prevImgs;
                const worker = await createWorker('eng');
                let { data: { text } } = await worker.recognize(img);
                await worker.terminate();
                return this.checkAll(text);
            } catch(e) {
                this.$errorToast('Try again with different image!')
            }
        },
        async fileUpdateFunc(event) {
            this.has_edited_utr = 1
            try{
                this.file = event.target.files[0];
                const file = event.target.files[0];
                this.previewImageUtr = URL.createObjectURL(file)
                let response = await onUploadImage({
                    event,
                    depositAmount: this.depositAmount,
                    startTimer: this.startTimer,
                    resetTimer: this.resetTimer,
                    sbtBtn: this.$refs.sbtBtn,
                    checkAll: this.checkAll
                });
                if(response){
                    this.manual_utr = response?.manual_utr
                    this.utrMsg = response?.utrMsg
                    this.uploadedImage = response?.uploadedImage
                    this.previewImageUtr = response?.previewImage
                    this.utrNumber = response?.tesseract_utr
                    this.fetchedUtr = response?.tesseract_utr
                    this.utrLoader = false
                }
                else{
                    // this.previewImage = null
                    // this.fetchedUtr = null
                    // this.previewImageUtr = null
                }
                this.validateUTR()
            }
            catch(error){
                this.$errorToast(this.$t('try-again-with-different-image', 'Try again with different image!'));
            }
        },
        clearPaymentSlip() {
            this.has_edited_utr = 1
            this.previewImageUtr = null;
            this.utrNumber = null;
            this.file = undefined;
            this.uploadedImage = null
            this.loading = false

            this.validateUTR();
        },
        async goToPaymentGateway() {
            try {
                const response = await getPaymentGatewayUrl(this.depositAmount, this.selectedPaymentDetails[0].master_account_id);
                console.log(response)
            } catch (error) {
                this.$errorToast(error)
            }
        },
        choosePaymentMethod(payment, index){
            this.clearPaymentSlip()
            // this.toggleInit(false)
            if(payment?.[0]?.method == 'social'){
                const socialNumber = payment?.[0]?.social_payment_number;
                const socialLink = payment?.[0]?.social_payment_link;
                if (socialNumber?.length && socialLink?.length) {
                    const choice = Math.random() < 0.5 ? 'number' : 'link';
                    if (choice === 'number') {
                        if (payment?.[0]?.method_name?.toLowerCase().includes('whatsapp')) {
                            window.open(`https://wa.me/?text=${socialNumber}`, 'blank');
                        } else if (payment?.[0]?.method_name?.toLowerCase().includes('telegram')) {
                            window.open(`https://t.me/${socialNumber}`, 'blank');
                        }
                    } else {
                        window.open(socialLink, 'blank');
                    }
                    return;
                }
                if (socialNumber?.length) {
                    if (payment?.[0]?.method_name?.toLowerCase().includes('whatsapp')) {
                        window.open(`https://wa.me/?text=${socialNumber}`, 'blank');
                    } else if (payment?.[0]?.method_name?.toLowerCase().includes('telegram')) {
                        window.open(`https://t.me/${socialNumber}`, 'blank');
                    }
                    return;
                }
                if (socialLink?.length) {
                    window.open(socialLink, 'blank');
                    return;
                }
                this.$errorToast(this.$t('no-social-payment-number', 'No social payment number available'));
                return;
            };
            if(payment?.[0]?.method == 'payment_gateway'){
                this.isPaymentGateway = true;
                this.selectedPaymentDetails = payment;
                return
            }
            this.activeTab = index
            this.selectedPaymentDetails = payment
            this.selectPaymentAccount = this.selectedPaymentDetails?.[0]
            this.isPaymentGateway = false;
            this.showFileError = false
            this.utrerror = false
            this.init = false
        },
        validateUTR() {
            this.utrNumber = this.utrNumber?.replace(/[^0-9]/g, '').replace(/[+-]/g, '');
            if (!this.utrNumber) {
                this.utrerror = true;
                this.utrLimitError = false; 
            } else if (this.utrNumber.length < 10 || this.utrNumber.length > 15) {
                this.utrerror = false;
                this.utrLimitError = true;
            } else {
                this.utrerror = false;
                this.utrLimitError = false;
            }
        },
        startTimer() {
            this.utrLoader = true;
            this.timer = setInterval(() => {
                this.intervalCounter++;
                this.angle += this.angle_increment / (1000 / this.interval);

                // Update the timer value based on the angle
                this.timerValue = this.t - Math.floor((this.angle / 360) * this.t);

                if (this.angle >= 360) {
                clearInterval(this.timer);
                }
                if (this.timerValue <= 0) {
                    this.resetTimer();
                    // this.$errorToast('Time out! Please try again with a different image or manually enter the UTR number.');
                    this.utrLoader = false;
                }
            }, this.interval);
        },
        resetTimer() {
            clearInterval(this.timer);
            this.utrLoader = false;
            this.angle = 0;
            this.intervalCounter = 0;
            this.timerValue = this.t;
        },
    }

}
</script>